import Layout from "@/layout/Layout.vue";
import { P } from "@/config/permissions";

const stockRoutes = {
    path: "/stock",
    name: "stock",
    component: Layout,
    redirect: "/stock/dashboard",
    alwaysShow: true,
    meta: {
        title: "Stock",
        icon: "mdi:package-variant-closed",
        permissions: [P.STOCK.CATALOG_BROWSE],
        noCache: true
    },
    children: [
        // ─── Tableau de bord ──────────────────────────────
        {
            path: "dashboard",
            name: "stock-dashboard",
            meta: {
                title: "Tableau de bord",
                icon: "mdi:view-dashboard-outline",
                noCache: true,
                permissions: [P.STOCK.CATALOG_BROWSE]
            },
            component: () => import("@/views/stock/StockDashboard.vue")
        },

        // ─── Catalogue (produits, marques, types, modèles) ─
        {
            path: "catalogue",
            name: "stock-catalogue",
            meta: {
                title: "Catalogue",
                icon: "mdi:package-variant",
                noCache: true,
                permissions: [P.STOCK.CATALOG_BROWSE]
            },
            component: () => import("@/views/stock/CataloguePage.vue")
        },
        {
            path: "products/:id(\\d+)",
            name: "stock-product-show",
            meta: {
                title: "Détail produit",
                noCache: true,
                permissions: [P.STOCK.CATALOG_BROWSE]
            },
            component: () => import("@/views/stock/showProduct.vue"),
            hidden: true
        },

        // ─── Produits (liste filtrée, route deep-link) ─────────
        {
            path: "products",
            name: "stock-products",
            meta: {
                title: "Produits",
                noCache: true,
                permissions: [P.STOCK.CATALOG_BROWSE]
            },
            component: () => import("@/views/stock/Products.vue"),
            hidden: true
        },

        // ─── Inventaire (exemplaires, emplacements, alertes) ─
        {
            path: "inventaire",
            name: "stock-inventaire",
            meta: {
                title: "Inventaire",
                icon: "mdi:warehouse",
                noCache: true,
                permissions: [P.STOCK.INVENTORY_BROWSE],
                // Pastille : mes alertes de stock non lues — c'est l'onglet
                // « Alertes » de cet écran que les notifications ouvrent.
                badgeKey: "stock"
            },
            component: () => import("@/views/stock/InventairePage.vue")
        },

        // ─── Mouvements ───────────────────────────────────
        {
            path: "mouvements",
            name: "stock-movements",
            meta: {
                title: "Mouvements",
                icon: "mdi:swap-horizontal",
                noCache: true,
                permissions: [P.STOCK.INVENTORY_BROWSE]
            },
            component: () => import("@/views/stock/StockMovements.vue")
        },

        // ─── Achats & Réceptions ──────────────────────────
        {
            path: "achats",
            name: "stock-achats",
            meta: {
                title: "Achats & réceptions",
                icon: "mdi:cart-arrow-down",
                noCache: true,
                permissions: [P.STOCK.ORDERS_BROWSE]
            },
            component: () => import("@/views/stock/AchatsReceptionsPage.vue")
        },
        {
            path: "receptions/:id(\\d+)/scan",
            name: "stock-reception-scan",
            meta: {
                title: "Scan réception",
                noCache: true,
                permissions: [P.STOCK.RECEPTION_BROWSE]
            },
            component: () => import("@/views/stock/StockReceptionScan.vue"),
            hidden: true
        },

        // ─── Scan sortie (matos → client) ──────────────────
        {
            path: "out-scan",
            name: "stock-out-scan",
            meta: {
                title: "Scan sortie",
                icon: "mdi:logout-variant",
                noCache: true,
                permissions: [P.STOCK.INVENTORY_MANAGE]
            },
            component: () => import("@/views/stock/StockOutScan.vue")
        },

        // ─── Rétro-compatibilité (redirections vers nouveaux chemins) ─
        { path: "brands",        redirect: "/stock/catalogue?tab=brands",      hidden: true },
        { path: "product-types", redirect: "/stock/catalogue?tab=types",       hidden: true },
        { path: "product-models", redirect: "/stock/catalogue?tab=models",     hidden: true },
        { path: "product-items", redirect: "/stock/inventaire?tab=items",      hidden: true },
        { path: "locations",     redirect: "/stock/inventaire?tab=locations",  hidden: true },
        { path: "alerts",        redirect: "/stock/inventaire?tab=alerts",     hidden: true },
        { path: "movements",     redirect: "/stock/mouvements",                hidden: true },
        { path: "purchase-orders", redirect: "/stock/achats?tab=orders",       hidden: true },
        { path: "receptions",    redirect: "/stock/achats?tab=receptions",     hidden: true }
    ]
};

export default stockRoutes;
